import * as React from "react";
import { IBaseLink } from "~/types/link";

export interface IFooterBottomProps {
    footerBottomCopyrightLabel: string;
    footerBottomLinks: IBaseLink[];
}

const FooterBottom: React.SFC<IFooterBottomProps> = props => {
    const listItems = props.footerBottomLinks.map((link, index) => (
        <li className="footer-bottom__item" key={index}>
            <a className="footer-bottom__link" target={link.target} href={link.url}>
                {link.label}
            </a>
        </li>
    ));

    return (
        <div className="footer-bottom">
            <div className="footer-bottom__inner">
                <ol className="footer-bottom__items">{listItems}</ol>
                <span className="footer-bottom__copyright-notice">{props.footerBottomCopyrightLabel}</span>
            </div>
        </div>
    );
};

export default FooterBottom;
